{
  "about": {
    "paragraph": "Wir sind bestrebt, die Herausforderungen des AGEC-Gesetzes zu bewältigen und unsere Kunden über die Herkunft und Umweltqualitäten unserer Produkte zu informieren.",
    "title": "Über"
  },
  "lastUpdate": "Letztes Aktualisierungsdatum: ",
  "loading": {
    "dataPending": "sammelt derzeit diese Informationen",
    "pendingLocation": "Ausstehender Standort"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Bekleidungsherstellung",
    "FOOTWEAR_FINISHING": "Schuhveredelung",
    "FOOTWEAR_STITCHING": "Schuhnähen",
    "FOOTWEAR_ASSEMBLING": "Schuhmontage",
    "FABRIC_WEAVING_OR_KNITTING": "Stoffweberei oder -stricken",
    "FABRIC_DYEING_PRINTING": "Stofffärbung oder -druck",
    "YARN_PROVIDER": "Garnlieferant",
    "YARN_DYEING_PRINTING": "Garnfärbung oder -druck",
    "LEATHER_TANNING": "Lederverarbeitung",
    "LEATHER_DYEING_PRINTING": "Lederfärbung oder -druck",
    "ACCESSORY_PROVIDER": "Zubehörlieferant",
    "YARN_MATERIAL_PRODUCTION": "Garnmaterialproduktion",
    "FABRIC_SPINNING": "Stoffspinnen",
    "FABRIC_MATERIAL_PRODUCTION": "Stoffmaterialproduktion",
    "LEATHER_MATERIAL_PRODUCTION": "Ledermaterialproduktion",
    "LEATHER_FARM": "Zuchtfarm",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Zubehör-Rohmateriallieferant",
    "COATING": "Beschichtung"
  },
  "other": {
    "microplastics_bold": "setzt Mikroplastik frei ",
    "paragraph1": "Dieses Produkt enthält ",
    "paragraph1_100": "Dieses Produkt enthält 100% recycelte Materialien.",
    "paragraph2_1": "Dieses Produkt ",
    "paragraph2_2": "  in die Umwelt beim Waschen: ",
    "paragraph2_3": "der Masse des Produkts besteht aus synthetischen Fasern.",
    "paragraph3": "Informationen über das mögliche Vorhandensein gefährlicher Stoffe in der Anwendung: ",
    "recycled_matertials_bold": "mindestens {{percent}}% recycelte Materialien.",
    "recycled_matertials_bold_50": "mehr als 50% ",
    "title": "Andere Umweltqualitäten und Eigenschaften"
  },
  "packaging": {
    "recyclable": "Recycelbar: Die Verpackung ist recycelbar.",
    "recycled": "Recycelte Materialien: Die Verpackung enthält mindestens {{percent}}% recycelte Materialien.",
    "recycled_100": "Recycelte Materialien: Die Verpackung enthält 100% recycelte Materialien.",
    "title": "Umweltqualitäten und Eigenschaften der Verpackung"
  },
  "title": "Produktblatt zu Umweltqualitäten oder -eigenschaften",
  "traceability": {
    "paragraph": "Dies bezieht sich auf die Herkunft Ihres Produkts in seinen ersten drei Produktionsstufen, von der Entstehung bis zum Weben und Färben seines Hauptmaterials.",
    "title": "Produktrückverfolgbarkeit"
  },
  "ecoScore": {
    "title": "EcoScore"
  }
}
